import React from "react";
import { components } from "react-select";
import {
  buildAutomationChildTestId,
  buildAutomationOptionTestId,
} from "../InputField/testId";

const AutomationControl = (props) => (
  <components.Control
    {...props}
    innerProps={{
      ...props.innerProps,
      "data-testid": buildAutomationChildTestId(props.selectProps?.automationTestId, "toggle"),
    }}
  />
);

const AutomationInput = (props) => (
  <components.Input
    {...props}
    data-testid={buildAutomationChildTestId(props.selectProps?.automationTestId, "input")}
  />
);

const AutomationOption = (props) => (
  <components.Option
    {...props}
    innerProps={{
      ...props.innerProps,
      "data-testid": buildAutomationOptionTestId(
        props.selectProps?.automationTestId,
        props.data?.value ?? props.label
      ),
    }}
  />
);

const AutomationClearIndicator = (props) => (
  <components.ClearIndicator
    {...props}
    innerProps={{
      ...props.innerProps,
      "data-testid": buildAutomationChildTestId(props.selectProps?.automationTestId, "clear"),
    }}
  />
);

export const withAutomationComponents = (componentOverrides = {}) => ({
  Control: AutomationControl,
  Input: AutomationInput,
  Option: AutomationOption,
  ClearIndicator: AutomationClearIndicator,
  ...componentOverrides,
});
